import { stylesConfig } from "../../helpers/stylesConfig";
import { useLocation, useNavigate } from "react-router";
import { COMMON_ALT, COMMON_WEB_PATH } from "../../constant";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, NavLink } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  AbsoluteCenter,
  Box,
  Flex,
  Image,
  Text,
  useBreakpointValue,
  useColorMode,
  useColorModeValue,
} from "@chakra-ui/react";
import useCheckLogin from "../../hook/useCheckLogin";
import HeaderAppDownload from "../../pages/App/HeaderAppDownload";
import Balance from "../Balance/Balance";
import ClearCashRegisterButton from "../ClearCash/ClearCashRegisterButton";
import MusicToggleButton from "./HeaderComponents/MusicToggleButton";
import ReloadButton from "./HeaderComponents/ReloadButton";
import LoginButton from "./HeaderComponents/LoginButton";
import UserButton from "./HeaderComponents/UserButton";
import LngButton from "./HeaderComponents/LngButton";
import BetRecordButton from "../BetRecordButton/BetRecordButton";
import AnnouncementButton from "./HeaderComponents/AnnouncementButton";
import HeaderDecorations from "../NewYearDecorations/components/HeaderDecorations";

const isCredit = process.env.REACT_APP_CREDIT == 1;

const Header = () => {
  const { t, i18n } = useTranslation();
  //const i18n = (key) => t(`common.${key}`);
  const i18n_header = (key) => t(`header.${key}`);
  const i18n_common = (key) => t(`common.${key}`);
  const i18n_profile = (key) => t(`profile.${key}`);

  const iconBg = useColorModeValue("#E9E8F2", "#262D47");
  // 取 登入狀態 機台相關的狀態
  const { isLogin, isMachineDomain, isMachineUser } = useCheckLogin();

  const memberInfo = useSelector((state) => state.isMemberInfo);

  const location = useLocation(); //返回一個location對象，其中包含當前URL的信息。它與window.location最大的區別是，它不會引起頁面重新加載。你可以在任何地方使用它，包括React Hooks組件中。

  const profilePath = useBreakpointValue({
    base: "profile",
    sm: "profile/data",
  });

  const gradientStyle = {
    color: "white",
    WebkitTextStroke: "1px #804ed2",
    textStroke: "1px #804ed2",
    textShadow: `
    -1px -1px 0 #804ed2,  
     1px -1px 0 #804ed2,
    -1px 1px 0 #804ed2,
     1px 1px 0 #804ed2
  `,

    display: "inline-block",
  };

  return (
    <Box
      width={{
        base: `100%`,
        xl: `100%`,
      }}
      minHeight={{
        base: "65px",
        sm: "70px",
        md: "100px",
        xl: "125px",
      }}
      position="fixed"
      mx="auto"
      top="0px"
      bgImage={{
        base: "",
        lg: `url(${COMMON_WEB_PATH}/theOne/header/header_machine_background_.png)`,
      }}
      bgColor={{
        base: "#1E111E",
        lg: "transparent",
      }}
      _after={{
        lg: {
          content: "''",
          position: "absolute",
          top: 0,
          left: 0,
          bgImage: null,
          bgSize: "100%100%",
          bgRepeat: "no-repeat",
          bgPosition: "center",
          w: "100%",
          h: "110%",
          pointerEvents: "none", // 確保不會阻止點擊事件
        },
      }}
      bgSize="102% 106%"
      zIndex={{
        base: "999",
        sm: "1001",
      }}
      display="flex"
      pt={{
        base: "0px",
        xl: "0px",
      }}
      pb={{
        base: "0px",
        lg: "10px",
      }}
      alignItems={
        isMachineUser
          ? "center"
          : {
              base: "center",
              lg: "center",
            }
      }
      justifyContent="space-between"
      // borderColor={headerBorder}
      pr={{
        base: "1%",
        md: "1%",
        lg: "1%",
        xl: "5%",
      }}
      pl={{
        base: isLogin ? "1%" : "3%",
        md: isLogin ? "1%" : "3%",
        lg: isMachineDomain || isMachineUser ? "1%" : "6%",
        xl: isMachineDomain || isMachineUser ? "1%" : "8%",
      }}
      // boxShadow={{
      //   base: "0 0 10px #804ed2, 0 0 20px #804ed2", // 光晕
      //   lg: "none",
      // }}
      transition="all 0.3s ease" // 過渡
    >
      {/* <HeaderAppDownload /> */}

      <Flex
        alignItems={{
          base: "center",
          md: "center",
        }}
        pt={{
          base: "0px",
          md: "unset",
        }}
        justifyContent={{
          base: "space-between",
          sm: "space-between",
        }}
        pl={{
          md: "0px",
          base: "0px",
          // lg: isGameBox ? "0px" : "245px",
        }}
        pr={{
          md: "0px",
          base: "0px",
        }}
        pb={{
          base: "0px",
          sm: "0px",
        }}
        width="100%"
        height="100%"
      >
        <Flex gap="25px" alignItems={"center"}>
          {/* 餘額 */}
          {isLogin ? (
            <Flex gap="5px" alignItems={"center"}>
              <Image
                display={{
                  base: "block",
                  lg: "none",
                }}
                w={{
                  base: "70px",
                }}
                h="50px"
                src={`${COMMON_WEB_PATH}/theOne/logo_512.gif`}
              />
              <Balance />
            </Flex>
          ) : (
            <>
              <Image
                display={{
                  base: "block",
                  lg: "none",
                }}
                w={{
                  base: "70px",
                }}
                h="50px"
                src={`${COMMON_WEB_PATH}/theOne/logo_512.gif`}
              />
            </>
          )}
          {isMachineUser || isMachineDomain ? (
            <Flex gap="10px">
              {/* 棄分按鈕 */}
              <ClearCashRegisterButton />
              {/* 投注記錄 */}
              <BetRecordButton />
            </Flex>
          ) : null}
        </Flex>
        <AbsoluteCenter
          display={{
            base: "none",
            lg: "block",
          }}
        >
          <Image
            w={{
              md: "250px",
              xl: "300px",
            }}
            // h="100px"
            objectFit={"cover"}
            src={`${COMMON_WEB_PATH}/theOne/logo_512.gif`}
            mt={'1.5em'}
          />
          <HeaderDecorations />
        </AbsoluteCenter>
        <Flex gap="30px">
          {isMachineUser || isMachineDomain ? (
            <Flex
              //w="auto"
              minW="160px"
              px="50px"
              gap="8px"
              height={{
                base: "60px",
                //xl: "85px",
                xl: isMachineUser ? "65px" : "65px",
              }}
              bgImage={`url('${COMMON_WEB_PATH}/theOne/header/uid_banner.png')`}
              bgPosition="center"
              bgRepeat="no-repeat"
              bgSize="100%100%"
              alignItems={"center"}
              justifyContent={"center"}
            >
              <Text
                color="transparent"
                sx={gradientStyle}
                fontSize={{
                  base: "xl",
                  //xl: "2xl",
                  xl: isMachineUser ? "30px" : "30px",
                }}
                fontWeight="900"
              >
                NO.{memberInfo?.uid || "-"}
              </Text>
            </Flex>
          ) : null}
          <Flex
            gap={{
              base: "5px",
              md: "10px",
            }}
          >
            <Box display={{base: 'none', sm: 'flex'}} gap={'0.5em'}>
                <LngButton />
                <ReloadButton />
                <MusicToggleButton />
                <AnnouncementButton />
            </Box>
            {isLogin ? (
              isMachineDomain || isMachineUser ? null : (
                <UserButton />
              )
            ) : (
              <LoginButton />
            )}
          </Flex>
        </Flex>
      </Flex>
    </Box>
  );
};

export default Header;
